
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {CalendarOffTimeRuleGetResponse} from './CalendarOffTimeRuleGetResponse';

/**
 * CalendarOffTimeRuleGetRequest struct
 */
class CalendarOffTimeRuleGetRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {UUID=} ruleId
   * @param {string=} ruleName
   * @constructor
   */
  constructor (parent = new Request(), ruleId = null, ruleName = null) {
    super()
    super.copy(parent)
    this.RuleId = ruleId
    this.RuleName = ruleName
  }

  /**
   * Copy struct (shallow copy)
   * @this {!CalendarOffTimeRuleGetRequest}
   * @param {!CalendarOffTimeRuleGetRequest} other Other struct
   * @returns {!CalendarOffTimeRuleGetRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.RuleId != null) {
      this.RuleId = new UUID(other.RuleId)
    } else {
      this.RuleId = null
    }
    if (other.RuleName != null) {
      this.RuleName = other.RuleName
    } else {
      this.RuleName = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!CalendarOffTimeRuleGetRequest}
   * @returns {!CalendarOffTimeRuleGetRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new CalendarOffTimeRuleGetRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new CalendarOffTimeRuleGetRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!CalendarOffTimeRuleGetRequest}
   * @param {!CalendarOffTimeRuleGetRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof CalendarOffTimeRuleGetRequest)) {
      throw new TypeError('Instance of CalendarOffTimeRuleGetRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!CalendarOffTimeRuleGetRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      RuleId: ((this.RuleId != null) ? this.RuleId.toString() : null),
      RuleName: ((this.RuleName != null) ? this.RuleName : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return CalendarOffTimeRuleGetRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!CalendarOffTimeRuleGetRequest} other Object value
   * @returns {!CalendarOffTimeRuleGetRequest} Created struct
   */
  static fromObject (other) {
    return new CalendarOffTimeRuleGetRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!CalendarOffTimeRuleGetRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return CalendarOffTimeRuleGetRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!CalendarOffTimeRuleGetRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5128
  }
}

export { CalendarOffTimeRuleGetRequest };

/**
 * Fast Binary Encoding CalendarOffTimeRuleGetRequest field model
 */
class FieldModelCalendarOffTimeRuleGetRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.RuleId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.RuleName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.RuleId.fbeOffset + this.RuleId.fbeSize), buffer, this.RuleId.fbeOffset + this.RuleId.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.RuleId.fbeSize + this.RuleName.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.RuleId.fbeExtra + this.RuleName.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelCalendarOffTimeRuleGetRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5128
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RuleId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RuleId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RuleId.fbeSize

    if ((fbeCurrentSize + this.RuleName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RuleName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RuleName.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @param {!CalendarOffTimeRuleGetRequest} fbeValue Default value, defaults is new CalendarOffTimeRuleGetRequest()
   * @returns {!CalendarOffTimeRuleGetRequest} CalendarOffTimeRuleGetRequest value
   */
  get (fbeValue = new CalendarOffTimeRuleGetRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @param {!CalendarOffTimeRuleGetRequest} fbeValue CalendarOffTimeRuleGetRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RuleId.fbeSize) <= fbeStructSize) {
      fbeValue.RuleId = this.RuleId.get()
    } else {
      fbeValue.RuleId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RuleId.fbeSize

    if ((fbeCurrentSize + this.RuleName.fbeSize) <= fbeStructSize) {
      fbeValue.RuleName = this.RuleName.get()
    } else {
      fbeValue.RuleName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RuleName.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @param {!CalendarOffTimeRuleGetRequest} fbeValue CalendarOffTimeRuleGetRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelCalendarOffTimeRuleGetRequest}
   * @param {CalendarOffTimeRuleGetRequest} fbeValue CalendarOffTimeRuleGetRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.RuleId.set(fbeValue.RuleId)
    this.RuleName.set(fbeValue.RuleName)
  }
}

export { FieldModelCalendarOffTimeRuleGetRequest };

/**
 * Fast Binary Encoding CalendarOffTimeRuleGetRequest model
 */
class CalendarOffTimeRuleGetRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelCalendarOffTimeRuleGetRequest(this.buffer, 4)
  }

  /**
   * Get the CalendarOffTimeRuleGetRequest model
   * @this {!CalendarOffTimeRuleGetRequestModel}
   * @returns {!FieldModelCalendarOffTimeRuleGetRequest} model CalendarOffTimeRuleGetRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!CalendarOffTimeRuleGetRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!CalendarOffTimeRuleGetRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return CalendarOffTimeRuleGetRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!CalendarOffTimeRuleGetRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelCalendarOffTimeRuleGetRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!CalendarOffTimeRuleGetRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!CalendarOffTimeRuleGetRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!CalendarOffTimeRuleGetRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!CalendarOffTimeRuleGetRequestModel}
   * @param {!CalendarOffTimeRuleGetRequest} value CalendarOffTimeRuleGetRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!CalendarOffTimeRuleGetRequestModel}
   * @param {!CalendarOffTimeRuleGetRequest} value CalendarOffTimeRuleGetRequest value, defaults is new CalendarOffTimeRuleGetRequest()
   * @return {!object} Deserialized CalendarOffTimeRuleGetRequest value and its size
   */
  deserialize (value = new CalendarOffTimeRuleGetRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new CalendarOffTimeRuleGetRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new CalendarOffTimeRuleGetRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!CalendarOffTimeRuleGetRequestModel}
   * @param {!number} prev Previous CalendarOffTimeRuleGetRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { CalendarOffTimeRuleGetRequestModel };
CalendarOffTimeRuleGetRequest.__has_response = true;
CalendarOffTimeRuleGetRequest.__response_class = CalendarOffTimeRuleGetResponse;
